import winterova from "../images/people/winterova.jpg";
import kafimola from "../images/people/kafimola.jpg";
import slachova from "../images/people/slachova.jpg";
import svobodova from "../images/people/svobodova.jpg";
import viky from "../images/people/viky.jpg";
import zorana from "../images/people/zorana.jpg";

export const studentsEn = [
 {
    id: `klobusicka`,
    name: `Viktorie Klobušická`,
    email: `505491@mail.muni.cz`,
    description: `Viktorie Klobušická completed her studies in Ecological and Evolutionary Biology and Zoology at Masaryk University (2020–2025). Her research focuses on the taxonomy of freshwater molluscs using molecular and morphological approaches. She is currently a PhD student specializing in Balkan lakes and their endemic species, with an emphasis on phylogenetic relationships and evolutionary diversity.`,
    researchgate: `https://www.researchgate.net/profile/Viktorie-Klobusicka`,
    is: `https://is.muni.cz/auth/osoba/505491`,
    img: viky,
  },
  {
    id: `slachova`,
    name: `Karolína Slachová`,
    email: `473661@mail.muni.cz`,
    description: `Karolína Slachová studied both the bachelor's and the master's degree programme Ecological and Evolutionary Biology at the Faculty of Science, Masaryk University in Brno. She specializes in vegetation ecology and during bachelor´s and master´s studies she was dealing with grasslands in the area of the White Carpathian Mts. She continues to focus on this vegetation also during her PhD studies, she intends to find out more about its determining factors, distribution and occurrence in other European areas (e.g. in the Balkan Peninsula).`,
    researchgate: `https://www.researchgate.net/scientific-contributions/Karolina-Slachova-2217674202`,
    is: `https://is.muni.cz/auth/osoba/473661`,
    img: slachova,
  },
  {
    id: `kafimola`,
    name: `Sara Kafimola`,
    email: `554659@mail.muni.cz`,
    description: `Sara Kafimola studied Zoology for her bachelor's degree. Then, in her Master's, she specialized in taxonomy and animal systematics. Her Master's thesis focused on the molecular phylogeny of the Anatolian rock lizard in the Middle East. She is a PhD student at the Department of botany and zoology, field Ecology. In her Ph.D. thesis, she works on the role of climatic stability and refugia on the genetic diversity of micro land-snails across the Holarctic.`,
    researchgate: `https://www.researchgate.net/profile/Sara_Kafimola`,
    is: `https://is.muni.cz/auth/osoba/554659`,
    img: kafimola,
  },
  {
    id: `svobodova`,
    name: `Kristina Svobodová`,
    email: `470305@mail.muni.cz`,
    description: `Kristina Svobodová graduated from the Faculty of Science at Masaryk University, majoring in Ecological and Evolutionary Biology. In her bachelor thesis she focused on the role of dead wood and the presence of beech trees in preserving the diversity of forest malacofauna, especially in spruce monocultures. She also devoted herself to this topic during her follow-up master's studies of zoology, which she completed in 2023. Now, during her doctoral studies at the Department of botany and zoology, she is studying the gastropod diversity of Central European forests from a contemporary and historical perspective. She would like to contribute to maintaining species richness of spruce monocultures and help to expand knowledge of nature in the Holocene using paleoecological reconstructions.`,
    researchgate: ``,
    is: `https://is.muni.cz/auth/osoba/470305`,
    img: svobodova,
  },
  {
    id: `winterova`,
    name: `Barbora Winterová`,
    email: `423852@mail.muni.cz`,
    description: `Barbora Winterová studied Zoology with specialisation in Vertabratology, at Faculty of Science of Masaryk University. She graduated in 2020. Even though working on behavioural ecology of amphibians in her Bachelor and Master theses, her PhD studies are focused on more general macroecology questions, in particular how dispersal barriers influence biodiversity and community ecology patterns of coral reefs from local to global scales.  `,
    researchgate: `https://www.researchgate.net/profile/Barbora_Winterova2`,
    is: `https://is.muni.cz/auth/osoba/423852`,
    img: winterova,
  },
   {
    id: `zorana`,
    name: `Zorana Kostadinović`,
    email: `500280@mail.muni.cz`,
    description: `Zorana Kostadinović completed her Bachelor's degree in Ecological and Evolutionary Biology and a subsequent Master's degree in Botany with a specialization in Phycology and Mycology at Masaryk University, graduating in 2026. Her research focused on changes in diatom communities in spring fen habitats of the Western Carpathians. In her doctoral studies, she continues in the same research direction, expanding it to include molecular analyses of cryptic species and investigations of changes in the functional diversity of diatom assemblages.`,
    researchgate: ``,
    is: `https://is.muni.cz/auth/osoba/500280`,
    img: zorana,
  },
];

export const studentsCz = [  {
    id: `klobusicka`,
    name: `Viktorie Klobušická`,
    email: `505491@mail.muni.cz`,
    description: `Viktorie Klobušická vystudovala na Masarykově univerzitě bakalářský obor Ekologická a evoluční biologie a následně i navazující magisterský obor Zoologie (2020–2025). Ve svém studiu se zaměřuje na taxonomii sladkovodních měkkýšů s využitím molekulárních a morfologických metod. V současnosti se v rámci doktorského studia specializuje na balkánská jezera a jejich endemické druhy, se zaměřením na jejich fylogenetické vztahy a evoluční diverzitu.`,
    researchgate: `https://www.researchgate.net/profile/Viktorie-Klobusicka`,
    is: `https://is.muni.cz/auth/osoba/505491`,
    img: viky,
  },
  {
    id: `slachova`,
    name: `Karolína Slachová`,
    email: `473661@mail.muni.cz`,
    description: `Karolína Slachová vystudovala bakalářský a magisterský program Ekologická a evoluční biologie na Přírodovědecké fakultě Masarykovy univerzity v Brně. Jejím zaměřením je vegetační ekologie a ve své bakalářské i diplomové práci se zabývala loukami na území Bílých Karpat. Při svém doktorském studiu se nadále věnuje této vegetaci, zajímá ji zejména její rozšíření i jinde v Evropě (například na balkánském poloostrově) a faktory, které jej předurčují.`,
    researchgate: `https://www.researchgate.net/scientific-contributions/Karolina-Slachova-2217674202`,
    is: `https://is.muni.cz/auth/osoba/473661`,
    img: slachova,
  },
  {
    id: `kafimola`,
    name: `Sara Kafimola`,
    email: `554659@mail.muni.cz`,
    description: `Sara Kafimola získala bakalářský titul v oboru Zoologie. V magisterském studiu se poté specializovala na taxonomii a systematiku živočichů. Ve své diplomové práci se věnovala molekulární fylogenezi ještěrek anatolských na Blízkém východě. Nyní je studentkou doktorského programu na Ústavu botaniky a zoologie, obor Ekologie. Ve svém doktorském studiu se zabývá vlivem klimatické stability a refugií na genetickou diverzitu drobných suchozemských plžů holarktické oblasti.`,
    researchgate: `https://www.researchgate.net/profile/Sara_Kafimola`,
    is: `https://is.muni.cz/auth/osoba/554659`,
    img: kafimola,
  },
  {
    id: `svobodova`,
    name: `Kristina Svobodová`,
    email: `470305@mail.muni.cz`,
    description: `Kristina Svobodová vystudovala na Přírodovědecké fakultě Masarykovy univerzity obor Ekologická a evoluční biologie. V rámci své bakalářské práce se zaměřila na úlohu mrtvého dřeva a přítomnosti buku pro zachování diverzity lesní malakofauny především ve smrkových monokulturách. Tomuto tématu se věnovala i při navazujícím magisterském studiu oboru zoologie, které dokončila v roce 2023. Nyní se při svém doktorském studiu na Ústavu botaniky a zoologie věnuje otázce diverzity plžů středoevropských lesů v současném a historickém pohledu. Ráda by přispěla k udržení druhové bohatosti smrkových monokultur a pomohla rozšířit poznání přírody v Holocénu pomocí paleoekologických rekonstrukcí.`,
    researchgate: ``,
    is: `https://is.muni.cz/auth/osoba/470305`,
    img: svobodova,
  },
  {
    id: `winterova`,
    name: `Barbora Winterová`,
    email: `423852@mail.muni.cz`,
    description: `Barbora Winterová vystudovala Zoologii, směr Vertebratologie, na Přírodovědecké fakultě Masarykovy univerzity. Promovala roku 2020. Ačkoli se během svých bakalářských a magisterských studií věnovala behaviorální ekologii obojživelníků, během současného, doktorského, studia oboru Ekologie se zaměřuje na obecnější otázky makroekologie. Konkrétně se věnuje vlivu bariér na biodiverzitu a ekologii společenstev, který by ráda zkoumala na různých škálách, od lokálních po globální, a na různých modelových systémech, včetně korálových útesů.`,
    researchgate: `https://www.researchgate.net/profile/Barbora_Winterova2`,
    is: `https://is.muni.cz/auth/osoba/423852`,
    img: winterova,
  },
   {
    id: `zorana`,
    name: `Zorana Kostadinović`,
    email: `500280@mail.muni.cz`,
    description: `Zorana Kostadinović vystudovala na Masarykově univerzitě bakalářský obor Ekologická a evoluční biologie a navazující magisterský obor Botanika se zaměřením na fykologii a mykologii, který ukončila v roce 2026. Ve svém studiu se zaměřila na změny rozsivkových společenstev ve slatiništích Západních Karpat. V doktorském studiu pokračuje ve stejném výzkumném zaměření, které rozšiřuje o molekulární analýzu kryptických druhů a studium změn ve funkční diverzitě rozsivkových společenstev.`,
    researchgate: ``,
    is: `https://is.muni.cz/auth/osoba/500280`,
    img: zorana,
  },
];
